module.exports = __webpack_public_path__ + "static/media/SNHU_logo.e2f31720.png";